import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import lang_45global from "/vercel/path0/src/middleware/lang.global.ts";
import user_45global from "/vercel/path0/src/middleware/user.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  lang_45global,
  user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/vercel/path0/src/middleware/admin.ts"),
  auth: () => import("/vercel/path0/src/middleware/auth.ts"),
  "car-rental": () => import("/vercel/path0/src/middleware/carRental.ts"),
  "cms-permission": () => import("/vercel/path0/src/middleware/cmsPermission.ts"),
  news: () => import("/vercel/path0/src/middleware/news.ts"),
  "no-auth": () => import("/vercel/path0/src/middleware/noAuth.ts"),
  "redirect-after": () => import("/vercel/path0/src/middleware/redirectAfter.ts"),
  "reset-password-token": () => import("/vercel/path0/src/middleware/resetPasswordToken.ts")
}